import React, { Component } from "react";
import { connect } from "react-redux";
import { FaInstagram, FaFacebookF, FaTwitter } from "react-icons/fa";

import A from "../../../shared/Anchor/Anchor";
import Link from "../../Link/Link";
import Login from "../HeaderMenu/Login/Login";
import LoginIcon from "../../Icons/Login";
import Assistenza from "../../Icons/Assistenza";
import Spedizione from "../../Icons/Spedizione";

import "./TopHeader.scss";

class TopHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showLogin: false,
    };
  }

  // LOGIN
  toggleLogin = (event) => {
    event.preventDefault();

    this.setState({
      showLogin: !this.state.showLogin,
    });
  };

  closeLogin = (event) => {
    this.setState({
      showLogin: false,
    });
  };

  render() {
    const { showLogin } = this.state;
    const {
      isCheckout,
      user,
      isAuthenticated,
      onLogin,
      phone,
      hasBlog,
      posts,
      couponPageUrl,
      loginError,
      primaryColor,
      datiFarmacia,
      createUser,
      facebookAppId,
      hasFacebookLogin,
      shippingDescription,
    } = this.props;

    return (
      <div className="top-header" style={{ backgroundColor: primaryColor }}>
        <div className="desktop-version">
          {!isCheckout && (
            <div className="container">
              <div className="left-top-header">
                <nav className="navbar navbar-expand-sm m-0 p-0">
                  <ul className="navbar-nav">
                    <li>
                      <Link
                        to="#"
                        className="link d-inline-block py-1 pr-2 pl-0 mr-2 text-white"
                      >
                        Offerte
                      </Link>
                    </li>
                    {!!hasBlog && posts.length > 0 && (
                      <li>
                        <Link
                          to="#"
                          className="link d-inline-block py-1 px-2 mr-2 text-white"
                        >
                          Blog
                        </Link>
                      </li>
                    )}
                    <li>
                      <Link
                        to="#"
                        className="link d-inline-block py-1 px-2 mr-2 text-white"
                      >
                        Contatti
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="link d-inline-block py-1 px-2 mr-2 text-white"
                      >
                        Servizi
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="link d-inline-block py-1 px-2 mr-2 text-white"
                      >
                        Info acquisti
                      </Link>
                    </li>
                    {!!hasBlog && !!couponPageUrl && (
                      <li>
                        <a
                          className="link d-inline-block py-1 px-2 mr-2 text-white"
                          href="#"
                        >
                          Coupon
                        </a>
                      </li>
                    )}
                  </ul>
                </nav>
              </div>
              <div className="right-top-header">
                <nav className="navbar navbar-expand-sm navbar-right p-0">
                  {!isAuthenticated ? (
                    <Login
                      user={user}
                      isAuthenticated={isAuthenticated}
                      onLogin={onLogin}
                      showLogin={showLogin}
                      onToggleLogin={this.toggleLogin}
                      onCloseLogin={this.closeLogin}
                      onCloseAll={this.closeLogin}
                      loginError={loginError}
                      primaryColor={primaryColor}
                      onLoginFacebook={this.props.onLoginFacebook}
                      facebookAppId={this.props.facebookAppId}
                      hasFacebookLogin={hasFacebookLogin}
                      createUser={createUser}
                    />
                  ) : (
                    <span className="welcome-user">
                      <Link to="#">
                        <LoginIcon /> Ciao{" "}
                        {user && user.billing && user.billing.firstname}
                      </Link>
                    </span>
                  )}
                  {/* <Link to="/wistlist" className="text-white">
                    WishList
                  </Link> */}
                  {(datiFarmacia.socialTwitterLink ||
                    datiFarmacia.socialFacebookLink ||
                    datiFarmacia.socialInstagramLink) && (
                    <div className="social">
                      {datiFarmacia.socialTwitterLink && (
                        <A
                          className="social-link"
                          href={datiFarmacia.socialTwitterLink}
                          target="_blank"
                        >
                          <FaTwitter />
                        </A>
                      )}
                      {datiFarmacia.socialFacebookLink && (
                        <A
                          className="social-link"
                          href={datiFarmacia.socialFacebookLink}
                          target="_blank"
                        >
                          <FaFacebookF />
                        </A>
                      )}
                      {datiFarmacia.socialInstagramLink && (
                        <A
                          className="social-link"
                          href={datiFarmacia.socialInstagramLink}
                          target="_blank"
                        >
                          <FaInstagram />
                        </A>
                      )}
                    </div>
                  )}
                </nav>
              </div>
            </div>
          )}
        </div>

        <div className="mobile-version">
          {!isCheckout && (
            <div className="container">
              <div className="mobile-top-header">
                <div className="spedizioni">
                  <Spedizione /> {shippingDescription}
                </div>
                <div className="assistenza">
                  <Assistenza />{" "}
                  <a href={"tel:" + phone} style={{ color: "white" }}>
                    {phone}
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    hasBlog: state.store.singleStore.hasBlog,
    posts: state.store.singleStore.posts,
    couponPageUrl: state.store.singleStore.couponPageUrl,
    loginError: state.user.error,
    datiFarmacia: state.store.singleStore,
    facebookAppId: state.store.singleStore.facebook.appId,
    hasFacebookLogin: state.store.singleStore.hasFacebookLogin,
    shippingDescription: state.store.singleStore.home.shippingDescription,
  };
}

export default connect(mapStateToProps)(TopHeader);
